import {
	Component,
	OnInit,
	Injector,
	AfterContentInit,
	Input,
	ElementRef,
	ViewContainerRef,
	ViewChild,
	DoCheck,
	ComponentFactoryResolver,
	HostListener,
} from '@angular/core';
import { BaseComponent } from '../../base.component';
import { isEmpty, get } from 'lodash';
import { getComponentName } from '../../../Utils/utils';
import { componentMap } from './../../Components';
import { AddressesService } from '../../../Services/addresses/Addresses';

@Component({
	selector: 'address-subcontrol',
	template: ` <ng-container #mountPoint class="hidden"><ng-container> </ng-container></ng-container> `,
})
export class AddressSubControlComponent extends BaseComponent implements OnInit {
	@ViewChild('mountPoint', { static: true, read: ViewContainerRef }) mountPoint;
	@Input() control: control;
	@Input() context: any;
	@Input() parentControl: any;
	setAnswer: any;
	setInitialAnswer: any;
	ajaxAction: any;
	request: request;
	class: any;
	style: any;

	constructor(
		injector: Injector,
		private el: ElementRef,
		private componentFactoryResolver: ComponentFactoryResolver,
		private Addresses: AddressesService
	) {
		super(injector);
	}

	ngOnInit() {
		this.createComponentData();
	}

	createComponentData() {
		const componentType = componentMap[getComponentName(this.control.controlType)];

		if (!componentType) {
			//throw new Error(`Component ${this.control.controlType} doesn't exist in components map`);
		}
		var factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
		const component = this.mountPoint.createComponent(factory);

		this.populateControlData();
		Object.assign(component.instance, {
			control: this.control,
			context: this.context,
			value: this.value,
			error: this.error,
			auditing: this.auditing,
			'[ngClass]': this.class,
			setAnswer: this._setAnswer,
			setInitialAnswer: this.setInitialAnswer,
			'ajax-action': this._ajaxAction,
			name: this.control.name,
			style: this.style,
		});
	}

	populateControlData() {
		this.value = this.storeService.getValue(this.control.name, this.context);
		this.error = this.storeService.getError(this.control, this.context);
		this.auditing = this.storeService.getAuditing(this.control, this.context);
		this.class = get(this.control, 'attributes.class');
		if (this.control.attributes && this.control.attributes.style) {
			this.style = this.control.attributes.style;
		}
		//this.setInitialAnswer = this._setAnswer(this.value);
		//this.ajaxAction = this._ajaxAction;
	}

	ngAfterViewInit() {
		const elem = this.elementRef.nativeElement.querySelectorAll('input')[0];
		this.Renderer.setAttribute(elem, 'aria-describedby', this.parentControl.name + '_error');
	}

	@HostListener('input') zipchange() {
		let name = this.control.name.split('.')[2];
		if (name == 'ZipCode') {
			this.Addresses.onZipChange(
				this.parentControl,
				this.storeService.getValue(this.control.name, this.context),
				false
			);
		}
		if (name == 'City') {
			this.Addresses.onCityChange(this.parentControl);
		}
	}

	@HostListener('focusout') zipBlur() {
		let name = this.control.name.split('.')[2];
		if (name == 'ZipCode') {
			this.Addresses.onZipBlur(this.parentControl, this.storeService.getValue(this.control.name, this.context));
		}
		if (name == 'AddressLine1') {
			this.Addresses.onAddressBlur(this.parentControl);
		}
	}

	async _setAnswer(value) {
		const { name, ajaxInfo } = this.control;
		this.storeService.updateData(name, value, this.context);
		if (!isEmpty(this.control.ajaxInfo) && !isEmpty(this.control.ajaxInfo.action)) {
			this.request = Object.assign(
				{},
				{
					data: this.storeService.getAnswers(this.context),
					info: this.control.ajaxInfo,
				}
			);
			return await this.actionService.invokeAction(this.request, true);
		}
	}

	async _ajaxAction() {
		this.request = Object.assign(
			{},
			{
				data: this.storeService.getAnswers(this.context),
				info: this.control.ajaxInfo,
			}
		);
		return await this.actionService.invokeAction(this.request, true);
	}
}
